// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CreateSocialItem-cls1__c1be958aa7fca77ef50b{/*!*/}.CreateSocialItem-cls2__c56a11edc58e4523ad14{height:48px;width:48px;margin-right:-12px;padding:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CreateSocialItem-cls1__c1be958aa7fca77ef50b",
	"cls2": "CreateSocialItem-cls2__c56a11edc58e4523ad14 CreateSocialItem-cls1__c1be958aa7fca77ef50b"
};
export default ___CSS_LOADER_EXPORT___;
